export default __webpack_public_path__ + "static/media/Brochure_gu.ffc3971f.pdf";